import { render, staticRenderFns } from "./AwaitingActivation.vue?vue&type=template&id=2ba1c550&scoped=true"
import script from "./AwaitingActivation.vue?vue&type=script&lang=ts"
export * from "./AwaitingActivation.vue?vue&type=script&lang=ts"
import style0 from "./AwaitingActivation.vue?vue&type=style&index=0&id=2ba1c550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1c550",
  null
  
)

export default component.exports